import * as yup from 'yup';

export const restCleanupCronJobsSchema = yup.object({
  cutoffDate: yup.string(),
  batchSize: yup.number(),
  max: yup.number(),
  maxTime: yup.number()
});

export const cleanupCronJobsSchema = () =>
  yup.object({
    config: yup.object().shape({
      count: yup.number(),
      parallelBatches: yup.number().integer().min(1).max(8),
      ...restCleanupCronJobsSchema.fields
    })
  });
